import type { DailyEntry } from "./db/schema"

/**
 * Update app badge to show "1" if user hasn't logged today
 * Clear badge if they have logged today
 *
 * Badge API support:
 * - iOS Safari 16.4+
 * - Desktop Safari
 * - Chrome/Edge Desktop
 * - NOT supported on Android
 */
export async function updateAppBadge(todayEntry?: DailyEntry): Promise<void> {
  // Check if Badge API is supported
  if (typeof window === "undefined" || !("setAppBadge" in navigator)) {
    return
  }

  try {
    if (!todayEntry) {
      // Show badge "1" if no entry today
      await navigator.setAppBadge(1)
    } else {
      // Clear badge if entry exists
      await navigator.clearAppBadge()
    }
  } catch (error) {
    // Silently fail if badge update fails
    console.warn("Failed to update app badge:", error)
  }
}

/**
 * Clear the app badge
 */
export async function clearAppBadge(): Promise<void> {
  if (typeof window === "undefined" || !("clearAppBadge" in navigator)) {
    return
  }

  try {
    await navigator.clearAppBadge()
  } catch (error) {
    console.warn("Failed to clear app badge:", error)
  }
}
